// third-party
import { configureStore } from '@reduxjs/toolkit';

import menu from './slices/menu';
import dashboard from './slices/dashboard';
import session from './slices/session';
import options from './slices/options';

import { debounce } from 'debounce';

import initialState from './initialState';

const KEY = 'session';
const loadState = () => {
    try {
        const serializedState = localStorage.getItem(KEY);
        if (!serializedState) {
            return undefined;
        }
        // console.log('base', initialState);
        const parsed = JSON.parse(serializedState);

        if ((parsed?.session?.version ?? 0) < initialState.session.version) {
            //discarding old version.
            console.log('discarding old state version');
            return undefined;
        } else {
            console.log('loading session');
        }

        //console.log('parsed', parsed);
        const merged = {
            ...initialState,
            session: {
                ...initialState.session,
                loggedIn: parsed.session.loggedIn,
                credentials: parsed.session.credentials
            },
            options: parsed.options
        };
        //console.log('merged', merged);
        return merged;
    } catch (e) {
        console.log(e);
        return undefined;
    }
};

const saveState = async (state) => {
    try {
        const dataToSave = {
            session: {
                version: state.session.version,
                loggedIn: state.session.loggedIn,
                credentials: state.session.credentials
            },
            options: state.options
        };
        const serializedState = JSON.stringify(dataToSave);
        localStorage.setItem(KEY, serializedState);
    } catch (e) {
        // Ignore
    }
};

const store = configureStore({
    reducer: {
        menu,
        dashboard,
        session,
        options
    },
    preloadedState: loadState()
});

const debounceSaveState = debounce(() => {
    saveState(store.getState());
}, 1000);

store.subscribe(() => {
    debounceSaveState();
});

const { dispatch } = store;

export { store, dispatch };
